module.exports = __webpack_public_path__ + "img/Deny-Logo.6999a7b8.svg";